import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=2112cc74&scoped=true"
import script from "./MessageModal.vue?vue&type=script&lang=js"
export * from "./MessageModal.vue?vue&type=script&lang=js"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=2112cc74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2112cc74",
  null
  
)

export default component.exports